












import { Component, Prop, Vue } from "vue-property-decorator";
import { LlmParameter, DefaultLlmParameter } from "#/model/admin/index";

@Component({})
/**
 * Claude設定
 */
export default class ClaudeSetting extends Vue {
  /** Prop */

  /** 入力値 */
  @Prop({ default: () => DefaultLlmParameter() }) value!: LlmParameter;

  /** 変数 */

  /** Claudeモデル選択肢 */
  private claudeChoice = [
    { text: "Claude Opus 4.8", value: "claude-opus-4-8" },
    { text: "Claude Sonnet 4.6", value: "claude-sonnet-4-6" },
    { text: "Claude Haiku 4.5", value: "claude-haiku-4-5" },
  ];
}
